import { Amplify } from 'aws-amplify';
import awsConfig from './aws-config';
Amplify.configure(awsConfig);
import React, { useState } from 'react';
import Dashboard from './screens/Dashboard';
import AddExpense from './screens/AddExpense';
import ExpenseList from './screens/ExpenseList';
import ScanReceipt from './screens/ScanReceipt';
import Reports from './screens/Reports';
import AIEstimate from './screens/AIEstimate';
import LoginScreen from './screens/LoginScreen';
import NavBar from './components/NavBar';
import './App.css';
const DEMO_MODE = false;
export const AppContext = React.createContext({});
function App() {
  const [currentScreen, setCurrentScreen] = useState('dashboard');
  const [isLoggedIn, setIsLoggedIn] = useState(DEMO_MODE);
  const [user, setUser] = useState(DEMO_MODE ? { username: 'demo@jobtrack.app', userId: 'demo-user-001' } : null);
  const [expenses, setExpenses] = useState([]);
  const [loading, setLoading] = useState(false);
  const [toast, setToast] = useState(null);
  const showToast = (message, type = 'success') => {
    setToast({ message, type });
    setTimeout(() => setToast(null), 3000);
  };
  const navigate = (screen) => setCurrentScreen(screen);
  const contextValue = {
    user,
    expenses,
    setExpenses,
    loading,
    setLoading,
    showToast,
    navigate,
    demoMode: DEMO_MODE
  };
  if (!isLoggedIn) {
    return (
      <LoginScreen
        onLogin={(userData) => {
          setUser(userData);
          setIsLoggedIn(true);
        }}
        demoMode={DEMO_MODE}
      />
    );
  }
  const screens = {
    dashboard: <Dashboard />,
    add: <AddExpense />,
    list: <ExpenseList />,
    scan: <ScanReceipt />,
    reports: <Reports />,
    estimate: <AIEstimate />
  };
  return (
    <AppContext.Provider value={contextValue}>
      <div className="app-shell">
        <div className="screen-container">
          {screens[currentScreen] || <Dashboard />}
        </div>
        <NavBar current={currentScreen} onNavigate={navigate} />
        {toast && (
          <div className={`toast toast--${toast.type}`}>
            {toast.type === 'success' ? '✓' : '!'} {toast.message}
          </div>
        )}
      </div>
    </AppContext.Provider>
  );
}
export default App;
